import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Box } from 'grommet';
import { Seo } from '@Components/Control';
import { AdminNavWrapper } from '@Components/Navigation';
import { useAppTheme } from '@Components/Context';
import {
  fetchAdminPrefillPricingRequest,
  clearAdminPrefillPricingRequest,
  initiateCreatePrefillOnboardingRequest,
  clearAdminPrefillOnboardingRequest,
} from '@Actions';
import { AdminPrefillWizard } from '@Components/Partial/Admin/CustomOnboarding';

const AdminCustomOnboardingPage = ({
  small,
  location,
  size = 'medium',
  loading,
  submitLoading,
  pricingData = null,
  prefillResult = null,
  fetchPricing,
  clearPricing,
  submitPrefill,
  clearPrefillResult,
}) => {
  const { theme: { page } } = useAppTheme();

  React.useEffect(() => {
    fetchPricing();
    return () => {
      clearPricing();
      clearPrefillResult();
    };
  }, []);

  const handleSubmit = (payload, onError) => {
    submitPrefill(payload, onError);
  };

  const handleReset = () => {
    clearPrefillResult();
  };

  return (
    <AdminNavWrapper
      small={small}
      location={location}
      bannerProps={{
        title: 'Custom Onboarding',
        subTitle: 'Onboarding · Admin',
      }}
    >
      <Seo />
      <Box
        flex
        direction="column"
        background={page.background}
        pad={{ vertical: '1.5rem', horizontal: '2rem' }}
        height="100%"
        width="100%"
      >
        <AdminPrefillWizard
          small={small}
          size={size || 'medium'}
          loading={loading}
          submitLoading={submitLoading}
          pricingData={pricingData}
          prefillResult={prefillResult}
          onSubmit={handleSubmit}
          onReset={handleReset}
        />
      </Box>
    </AdminNavWrapper>
  );
};

function mapStateToProps(state) {
  return {
    loading: state.fetchLoader.dataLoading,
    submitLoading: state.fetchLoader.submissionLoading,
    pricingData: state.adminCustomOnboarding.pricing,
    prefillResult: state.adminCustomOnboarding.prefillResult,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    fetchPricing: fetchAdminPrefillPricingRequest,
    clearPricing: clearAdminPrefillPricingRequest,
    submitPrefill: initiateCreatePrefillOnboardingRequest,
    clearPrefillResult: clearAdminPrefillOnboardingRequest,
  }, dispatch);
}

AdminCustomOnboardingPage.propTypes = {
  small: PropTypes.bool.isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
    search: PropTypes.string.isRequired,
    key: PropTypes.string.isRequired,
  }).isRequired,
  size: PropTypes.string,
  loading: PropTypes.bool.isRequired,
  submitLoading: PropTypes.bool.isRequired,
  pricingData: PropTypes.object,
  prefillResult: PropTypes.object,
  fetchPricing: PropTypes.func.isRequired,
  clearPricing: PropTypes.func.isRequired,
  submitPrefill: PropTypes.func.isRequired,
  clearPrefillResult: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(AdminCustomOnboardingPage);
